// comps
export { SettingsShortTextV1FieldComponent } from './settings-short-text-v1/settings-short-text-v1.component';
export { FillShortTextV1FieldComponent } from './fill-short-text-v1/fill-short-text-v1.component';
export { ViewShortTextV1FieldComponent } from './view-short-text-v1/view-short-text-v1.component';
